import type { TransformRow } from '../transforms/types';
import { RenderAdapterError, type RenderAdapterResult } from './types';

export function isValidRowsArray(rows: unknown): rows is TransformRow[] {
  if (!Array.isArray(rows)) {
    return false;
  }
  return rows.every(
    (row) => row !== null && typeof row === 'object' && !Array.isArray(row),
  );
}

export function validateRowsInput<TProps>(
  rows: unknown,
  emptyProps: TProps,
): RenderAdapterResult<TProps> | { rows: TransformRow[] } {
  if (!isValidRowsArray(rows)) {
    return {
      props: emptyProps,
      malformed: true,
      error: new RenderAdapterError('malformed_rows'),
    };
  }
  return { rows };
}
